import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", {
  class: "kakugo w100",
  style: {"height":"120px","top":"0","z-index":"10"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ofh w80 fl",
    style: {"margin-top":"25px"}
  }, [
    /*#__PURE__*/_createElementVNode("h4", {
      class: "fs20 ls1 fl",
      style: {"margin-left":"80px","margin-top":"24px"}
    }, [
      /*#__PURE__*/_createElementVNode("span", null, "メンバー設定")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_3 = {
  key: 0,
  class: "w100",
  style: {"height":"50px","text-align":"middle","border-bottom":"1px solid #ddd"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isSP)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.rm.userInfo && _ctx.showTabs)
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'members' ? 'selected fw600' : ''}`),
                style: {"width":"160px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectTab('members')))
              }, " 自社メンバー ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'client_user_groups' ? 'selected fw600' : ''}`),
                style: {"width":"180px"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTab('client_user_groups')))
              }, " 他社の招待グループ ", 2)
            ]))
          : _createCommentVNode("", true),
        _hoisted_4
      ]))
    : _createCommentVNode("", true)
}